import styled from 'styled-components';

const EBarEthicsResultDiv = styled.div`
  width: 100%;
`;

EBarEthicsResultDiv.displayName = 'EBarEthicsResultDiv';

export default EBarEthicsResultDiv;
